import {
    Autocomplete,
    AutocompleteProps,
    TextField,
    Typography,
} from '@mui/material'
import { getPxAsRem } from 'shared/utils'
import { StyledInputLabel } from '../styled'

interface Option {
    id: string
    value: string
}

type Multiple = boolean

interface ToggleEditSelectFieldProps<Multiple extends boolean | undefined>
    extends AutocompleteProps<Option, Multiple, false, false> {
    edit: boolean
    multiple?: Multiple
    label: string
    labelId: string
    error?: boolean
    helperText?: string
}

type Props = Omit<ToggleEditSelectFieldProps<Multiple>, 'renderInput'>

const ToggleEditAutocomplete = ({
    edit,
    label,
    labelId,
    disabled,
    value,
    error,
    helperText,
    ...rest
}: Props) => {
    let displayValue = Array.isArray(value)
        ? value.map((option) => option.value).join(', ')
        : value?.value

    if (edit)
        return (
            <Autocomplete
                {...rest}
                value={value}
                fullWidth
                id={labelId}
                isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                }
                getOptionLabel={(option) => option.value}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        placeholder=""
                        error={error}
                        helperText={helperText}
                        InputProps={{
                            ...params.InputProps,
                            sx: {
                                padding: `${getPxAsRem(14, 65, 14, 12)} !important`,
                            },
                        }}
                    />
                )}
                disabled={disabled}
            />
        )
    return (
        <>
            <StyledInputLabel>{label}</StyledInputLabel>
            <Typography variant="body1">{displayValue || '-'}</Typography>
        </>
    )
}

export default ToggleEditAutocomplete
